import { Moment } from "moment";
export type DivDataView = { division: string; dataView: string };

export const DivisionsAndDataViews = (): { [division: string]: string[] } => {
  return {
      Institutional: ['Contract'],
      QSR: [],
      FRS:[],
      Pest: [],
      Distributor: [],
    };
};

export enum Regions {
  AP = 'AP',
  EU = 'EU',
  IMEA = 'IMEA',
  LA = 'LA',
  NA = 'NA',
}

export type FilterOption = {
  id: string,
  title: string;
  required: boolean;
  isMultiple: boolean;
  hidden: boolean;
  disabled: boolean;
  optionList: string[];
  selected: string[];
  level: number;
  isLoading?: boolean;
  onChangeUpdate: number[];
  shownAfterId?: string;
  isSelectedFilter?: boolean;
};

export enum DistributorFilterModel {
  TopLevelContractGroup,
  SecondLevelContractFilter,
  Accts,
  Period
}

export enum ContractFilterModel {
  TopLevelContractGroup,
  SecondLevelContractFilter,
  ThirdLevelContractFilter,
  FourthLevelContractFilter,
  Period,
  Accts
}

export enum ContractFilterOptionsModel {
  Regions,
  Countries,
  TopLevelCustomerName,
  SecondLevelContractFilter,
  DateRange,
  CustomerNumberName,
}

export enum PestFilterModel {
  Regions,
  Countries,
  TopLevelCustomerName,
  SecondLevelContractFilter,
  DateRange,
  CustomerNumberName,
}

export enum QSRFilterOptionsModel {
  Regions,
  Countries,
  TopLevelCustomerName,
  SecondLevelContractFilter,
  DateRange,
  CustomerNumberName,
}

export enum FRSFilterOptionsModel {
  Regions,
  Countries,
  TopLevelCustomerName,
  SecondLevelContractFilter,
  DateRange,
  CustomerNumberName,
}

export type SelectedFilterOption = {
  Regions?: string[],
  Countries?: string[],
  CustomerNames?: string [],
  SubBrands?: string[],
  Accounts?: string[],
  DatePeriod?: string[],
  TopLevelContractGroup?: string [],
  SecondLevelGroup?: string [],
  ThirdLevelGroup?: string [],
  H5?: string [],
  H7?: string [],
  Templates?:string,
  TemplateTranslations?:string[],
};

export type CustomDateRange = {
  startDate: {
    moment:Moment,
    formatted: string
  },
  endDate: {
    moment:Moment,
    formatted: string
  }
};
